import { useState } from 'react';
import { lmsAxiosClient } from 'LearningManager/service/lmsClient';
import ACTIVITIES_API from 'Services/Api/Activities/Api';


const useLearnerCount = (tenantId: number | undefined) => {
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [userIds, setUserIds] = useState<string[]>([]);

	const getCount = async (mode: 'assigment' | 'course', params: any, isReset: boolean, activityId?: number): Promise<{ count: number, userIds: string[] }> => {
        try {
            setLoading(true);
            let url = ``;
            if(mode === 'assigment') url = `${ACTIVITIES_API.ASSIGNMENT_DETAILS}/users`;
            else if(mode === 'course' && activityId) url = `${ACTIVITIES_API.ACTIVITIES}/${activityId}/users`;

			const { data } = await lmsAxiosClient.get(url, { params: {
                offset: 0,
					...(tenantId ? { tenant_id: tenantId } : {}),
					...(isReset ? { has_progress: true } : {}),
                    ...params
            } });
            const users = (data?.data ?? []).flatMap((item: any) => item?.user_ids ?? []);
            const totalCount = data?.meta?.total || 0;
            setUserIds(users);
            setCount(data?.meta?.total || 0);
            return { count: totalCount, userIds: users };
        } catch {
            setCount(0);
            setUserIds([]);
            return { count: 0, userIds: [] };
        } finally {
            setLoading(false);
        }
    }

	return { userIds, count, loading, getCount };
};

export default useLearnerCount;